import React from 'react';
import { sanitizeHtmlAllowlist } from '../utils/sanitizeHtmlAllowlist';

/**
 * External HTML (e.g. Microsoft Secure Score remediation text).
 * Sanitises via allowlist — pages should not call dangerouslySetInnerHTML directly.
 */
export function SafeHtmlContent({ html, className, as: Tag = 'div' }) {
  const raw = html == null || html === '' ? '—' : String(html);
  const clean = sanitizeHtmlAllowlist(raw);

  return <Tag className={className} dangerouslySetInnerHTML={{ __html: clean }} />;
}
